<template>
  <div class="import_box">
    <point-select class="ad_type" :config="{ must: true }" labelText="广告类型" v-model="elType" :pList="adTypes">
      <div slot="empty" class="my-sel-empty__data">暂未开通，请联系管理员</div>
    </point-select>
    <el-form class="put_order_form">
      <el-form-item class="must" label="投放城市">
        <MultCityAsync ref="cityChoose" @change="getAddressCodes"></MultCityAsync>
      </el-form-item>
      <el-form-item label="投放时间" class="must" size="mini">
        <SearchTime v-model="searchTime"></SearchTime>
      </el-form-item>
      <el-form-item class="must" label="投放时段">
        <el-popover placement="bottom" trigger="click" popper-class="time-slot" @show="showTime = !showTime" @hide="showTime = !showTime">
          <div slot="reference" class="time_area">
            <span class="fl els">{{ timeStr }}</span>
            <i class="fr el-icon-arrow-down" :class="{ 'up': showTime }"></i>
          </div>
          <SearchTimeRange ref="timeRangeRef" :isInit="true" @submit="confirmTimeSegment"></SearchTimeRange>
        </el-popover>
      </el-form-item>
      <el-form-item class="must" label="单次曝光">
        <el-select placeholder="选择单次曝光" popper-class="form_pop" v-model="searchCondition.contentTime">
          <el-option v-for="t in exposeList" :key="t.dictItemCode" :value="t.dictItemName" :label="t.dictItemName+'秒'"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="must dmp" label="CPR+标签">
        <CprPlusLabel v-model="searchCondition.personsLabels"></CprPlusLabel>
      </el-form-item>
      <el-form-item class="must dmp" label="投放模式">
        <el-select placeholder="选择投放模式" popper-class="form_pop" v-model="searchCondition.dmpInterruptType">
          <el-option v-for="t in cprPlusModes" :key="t.value" :value="t.value" :label="t.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="number_input must" label="合同单价">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="9999"
          :precision="2"
          :step="0.1"
          v-model="searchCondition.unitPrice">
        </el-input-number>
        <i class="unit_append">元/千人次</i>
      </el-form-item>
      <el-form-item class="must number_input" label="流量总限">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="99999"
          :precision="2"
          :step="0.1"
          v-model="searchCondition.targetFlowOrbudgetAmount">
        </el-input-number>
        <i class="unit_append">千人次</i>
      </el-form-item>
      <el-form-item class="number_input" label="流量日限">
        <el-input-number
          size="mini"
          placeholder="请输入"
          :controls="false"
          :min="0.01"
          :max="99999"
          :precision="2"
          :step="0.1"
          v-model="searchCondition.dailyFlowLimit">
        </el-input-number>
        <i class="unit_append">千人次</i>
      </el-form-item>
      <PointLimit :limitFlow.sync="searchCondition.pointLimitFlow" :limitPlayCount.sync="searchCondition.pointLimitPlayCount"></PointLimit>
      <el-form-item class="must custom" label="合同编码">
        <el-input placeholder="请输入正确的合同编码" :maxlength="30" v-model="searchCondition.contractNo" @blur="contractHandle" @keyup.enter.native="contractHandle">
          <i slot="suffix" class="iconfont icon-biaodan-tianxie"></i>
        </el-input>
      </el-form-item>
      <!-- <el-form-item class="must custom" label="展现位置">
        <el-select placeholder="选择展现位置" popper-class="form_pop" v-model="searchCondition.displayRegion">
          <el-option v-for="reg in displayRegions" :key="reg.value" :label="reg.label" :value="reg.value"></el-option>
        </el-select>
      </el-form-item> -->
<!--      &lt;!&ndash;新禁播标签&ndash;&gt;-->
<!--      <el-form-item  label="禁播标签">-->
<!--        &lt;!&ndash;          <el-select placeholder="选择禁播标签" popper-class="form_pop" v-model="searchCondition.noPlayingLabels" multiple>&ndash;&gt;-->
<!--        &lt;!&ndash;            <el-option v-for="item in noPlayingLabels" :key="item.dictItemCode" :label="item.dictItemName" :value="item.dictItemName" ></el-option>&ndash;&gt;-->
<!--        &lt;!&ndash;          </el-select>&ndash;&gt;-->
<!--        <NoPlayingLabelSelector  v-model="searchCondition.noPlayingLabels"></NoPlayingLabelSelector>-->
<!--      </el-form-item>-->
      <el-button
        type="default"
        plain
        class="btn download_btn"
        icon="iconfont icon-download-template"
        @click="downloadTemplate">
        下载Excel模板
      </el-button>
      <el-upload
        class="upload_btn"
        :headers="upHeaders"
        :disabled="disable"
        :show-file-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        name="file"
        :action="config.importExcel"
        :with-credentials="true"
        :before-upload="beforeUpload"
        :on-progress="uploadProgress"
        :on-success="uploadSuccess">
        <el-button type="primary" class="btn import_btn" :class="{'is-disabled':disable}" icon="iconfont icon-shangchuananniu">
          {{importStatus === 2 ? '重新上传Excel文件' : '导入Excel文件' }}
        </el-button>
      </el-upload>
      <span class="upload_tip">仅支持xlsx格式，大小不超过6MB</span>
    </el-form>
  </div>
</template>

<script>
import PointSelect from '@/views/PutOrder/components/OrderForm/Select'
import SearchTime from './MySearchTime'
import CprPlusLabel from './CprPlusLabelSelect'
import PointLimit from './CprPlusPointLimit'
import NoPlayingLabelSelector from "@/components/NoPlayingLabelSelector";

export default {
  name: "ImportCondition",
  components: {
    NoPlayingLabelSelector,
    PointSelect,
    SearchTime,
    CprPlusLabel,
    PointLimit,
    SearchTimeRange: () => import('@/components/SearchTimeRange')
  },
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    importStatus: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      elType: [],
      fileObj: {
        name: '',
        progress: 0
      },
      searchTime: [],
      searchCondition: {
        orderLabels: ['L3','M1'],
        orderType: 6005, // CPR+订单类型值固定
        advertType: '',
        startDate: '',
        endDate: '',
        contentTime: '',
        personsLabels: [], // CPR+标签
        dmpInterruptType: 2, // 投放模式 1:标准 2:高级
        unitPrice: undefined,
        targetFlowOrbudgetAmount: undefined,
        dailyFlowLimit: undefined,
        pointLimitFlow: undefined,
        pointLimitPlayCount: undefined,
        contractNo: '',
        displayRegion: 1,
        searchTimeRange: [], // 投放时段
        noPlayingLabels:[],
      },
      timeStr: '',
      showTime: false,
      exposeList: [],
      importResultData: {}
    }
  },
  computed: {
    adTypes() {
      // CPR+广告 => CPR收费(2)、定制商业(3)、普通公益(4)、定制公益(5)
      const origin = this.$store.state.common.advertTypes || []
      const auth = origin.filter(e => [2, 3, 4, 5].indexOf(e.value) > -1)
      return auth.map(e => {
        e.code = e.value
        e.name = e.label
        return e
      })
    },
    cprPlusModes() {
      return this.$store.state.order.cprPlusModeList
    },
    upHeaders () {
      return {
        token: localStorage.getItem('user_ticket') || undefined
      }
    },
    disable() {
      const {
        advertType,
        addressCodes: regions,
        startDate,
        endDate,
        contentTime,
        personsLabels,
        dmpInterruptType,
        unitPrice,
        targetFlowOrbudgetAmount: limitAll,
        contractNo
      } = this.searchCondition

      if (!advertType) {
        return true
      }
      if (!regions || regions.length === 0) {
        if (this.$refs.cityChoose && !this.$refs.cityChoose.isWhole) {
          return true
        }
      }
      if (!startDate) return true
      if (!endDate) return true
      const adDuration = (contentTime || '').trim()
      if (!adDuration) return true
      if (!personsLabels || !personsLabels.length) return true
      if (dmpInterruptType === undefined) return true
      if (unitPrice === undefined) return true
      if (limitAll === undefined) return true
      if (!contractNo) return true

      return false
    },
    noPlayingLabels(){
      return this.$store.state.common['NEW_NO_PLAY_LABLE']
    }
  },
  watch: {
    searchTime (o) {
      if (!o || o.length < 2) return
      this.searchCondition.startDate = o[0]
      this.searchCondition.endDate = o[1]
    },
    importStatus (val) {
      this.$emit('update:importStatus', val)
    },
    elType(v) {
      this.searchCondition.advertType = v ? v[0] : undefined
    },
    searchCondition: {
      deep: true,
      handler (nv, ov) {
        this.triggerSearch()
      }
    }
  },
  async created() {
    if (!this.$store.state.bmap.labelTimeSlotList.length) await this.$store.dispatch('getTimeSlotList')
    this.exposeList = this.$store.state.bmap.labelTimeSlotList || []
    const defExp = this.exposeList.filter(e => e.default)[0] // 默认单次曝光
    if (defExp) {
      this.searchCondition.contentTime = defExp.dictItemName
    }
  },
  methods: {
    getAddressCodes(data, initData) { // 改成只传所有选中的最顶层节点
      if (initData) {
        this.searchCondition.addressCodes = initData
        return
      }
      let addressCodesParam = this.rmCheckItemChilds(data)
      this.searchCondition.addressCodes = addressCodesParam.map(el => el.split('^^').join('.')).map(el => el.indexOf('.') < 0 ? el + '.' : el)
    },
    rmCheckItemChilds(res) {
      let data = []
      let final = res.map(el => el.ids).sort()
      final.forEach(item => {
        data.forEach(el => {
          if ((item + '').indexOf(el) > -1) item = null
        })
        if (item) data.push(item + '')
      })
      return data
    },
    confirmTimeSegment({ data, type }) {
      const list = data || []
      this.timeStr = list.map(e => e.frequencyName).join('、')
      this.searchCondition.timeSegmentType = type
      this.searchCondition.searchTimeRange = list
    },
    contractHandle() {
      this.searchCondition.contractNo = (this.searchCondition.contractNo || '').trim()
    },
    async downloadTemplate () {
      await this.$exportGet(this.config.uploadTemplate)
    },
    beforeUpload (file) {
      if (file.size > 6 * 1024 * 1024) {
        this.$message.warning('文件大小超出限制')
        return false
      }
      this.fileObj.name = file.name
      this.fileObj.process = 0
      this.$emit('update:importStatus', 1)
    },
    uploadProgress (event, file, fileList) {
      this.fileObj.progress = event.percent
      this.$emit('progress', this.fileObj)
    },
    uploadSuccess (response, file, fileList) {
      this.$emit('update:importStatus', 2)
      this.fileObj.name = ''
      this.fileObj.process = 0
      if (response.code === 0) {
        this.importResultData = response.data
        this.triggerSearch()
      } else {
        this.$message.error(response.message || response.msg)
        this.importResultData = {}
      }
    },
    triggerSearch () {
      if (!this.importResultData || !this.importResultData.nbhdSearchList) return
      if (!this.testInput()) return
      this.$emit('search', { condition: this.searchCondition, result: this.importResultData })
    },
    testInput() {
      const {
        advertType,
        addressCodes: regions,
        startDate,
        endDate,
        contentTime,
        personsLabels,
        dmpInterruptType,
        unitPrice,
        targetFlowOrbudgetAmount: limitAll,
        dailyFlowLimit: dailyLimit,
        contractNo: contract
      } = this.searchCondition

      if (!advertType) {
        return this.messageTip('请选择广告类型', 2)
      }
      if (!regions || regions.length === 0) {
        if (this.$refs.cityChoose && this.$refs.cityChoose.isWhole) {
          // this.searchCondition.addressCodes = [1] // 全国传空数组
        } else {
          return this.messageTip('请选择投放城市', 2)
        }
      }
      if (!startDate) return this.messageTip('请选择投放开始日期', 2)
      if (!endDate) return this.messageTip('请选择投放结束日期', 2)
      if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
        return this.messageTip('结束日期须大于等于开始日期', 2)
      }
      if (new Date(endDate).getTime() - new Date(startDate).getTime() > 30 * 24 * 60 * 60 * 1000) {
        return this.messageTip('时间范围须小于等于31天', 2)
      }
      const adDuration = (contentTime || '').trim()
      if (!adDuration) return this.messageTip('请选择单次曝光', 2)

      if (!personsLabels || !personsLabels.length) return this.messageTip('请选择CPR+标签', 2)
      if (dmpInterruptType === undefined) return this.messageTip('请选择投放模式', 2)

      if (unitPrice === undefined) return this.messageTip('请输入合同单价', 2)
      if (unitPrice <= 0) return this.messageTip('合同单价须大于0', 2)
      if (limitAll === undefined) return this.messageTip('请填写流量总限', 2)
      if (dailyLimit <= 0) return this.messageTip('流量日限须大于0', 2)

      if (!contract) return this.messageTip('请输入合同编码', 2)

      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.import_box {
  width: 100%;
  .time_area {
    float: right;
    width: 220px;
    height: 38px;
    line-height: 38px;
    cursor: pointer;
    span {
      width: 192px;
      display: inline-block;
    }
    i {
      margin-left: 4px;
      margin-right: 10px;
      margin-top: 12px;
      color: #C0C4CC;
      &.up {
        transform: rotate(180deg);
      }
    }
  }
}
.ad_type {
  margin: 18px 17px;
  ::v-deep .el-form {
    .el-form-item {
      label.el-form-item__label {
        margin-top: 0;
        padding-bottom: 2px;
        transform: translateY(-50%);
        &::before {
          top: 4px;
        }
      }
    }
    .el-select .el-input input.el-input__inner {
      min-height: 40px;
      padding-left: 97px;
    }
  }
}
.put_order_form {
  margin: 18px 17px;
  .unit_append {
    color: #909399;
    width: 68px;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
  }
  ::v-deep .el-form-item {
    margin-bottom: 18px;
    border: 1px solid #E9E9E9;
    border-radius: 4px;
    height: 40px;
    padding-left: 17px;
    &.dmp {
      height: auto;
      .el-form-item__label {
        padding-right: 7px;
      }
    }
    &.custom .el-input {
      width: 230px;
      input {
        padding-right: 30px;
      }
    }
    &.number_input .el-input-number {
      width: 230px;
      input {
        width: 110px;
        text-align: left;
      }
    }
    .el-form-item__label {
      line-height: 20px;
      padding: 0 12px 0 0;
      margin: 9px 0;
      border-right: 1px solid #E9E9E9;
    }
    .el-form-item__content {
      line-height: 38px;
      padding-left: 70px;
      .dist_input {
        height: 100%;
        i {
          top: 12px;
        }
      }
      .el-range-editor--mini .el-range-input {
        font-size: 14px;
      }
      .el-input--mini {
        font-size: 14px;
      }
      .el-select {
        width: 100%;
        .el-input {
          width: 100%;
          .el-input__suffix {
            right: 10px;
          }
        }
      }
    }
    .el-input {
      input {
        border: none;
      }
      .el-input__inner {
        height: 38px;
        line-height: 38px;
        padding-left: 10px;
      }
    }
  }
  .el-input__inner {
    border: none !important;
  }
  .download_btn {
    width: 100%;
    margin-top: 7px;
    color: #FF3973;
    border: 1px solid #FF3973;
    &:hover {
      color: #FF3973;
      border: 1px solid #FF3973;
    }
  }
  .upload_btn {
    .import_btn {
      width: 100%;
      margin-top: 10px;
      margin-left: 0;
      background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
      border: none;
      &.is-disabled {
        background: #bbb;
      }
    }
    ::v-deep .el-upload {
      display: block;
    }
  }
  .upload_tip {
    display: block;
    text-align: center;
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    line-height: 17px;
  }
}
</style>
